import {
  PRIO,
  STATUS,
  ROLE,
  type Priority,
  type Status,
  type RaciRole,
} from "../lib/design";

export function PrioChip({ prio }: { prio: Priority }) {
  const p = PRIO[prio];
  return (
    <span className="chip" style={{ color: p.color, background: p.bg }}>
      {p.label}
    </span>
  );
}

export function StatusDot({ status }: { status: Status }) {
  const s = STATUS[status];
  return (
    <span
      title={s.label}
      style={{
        width: 8,
        height: 8,
        borderRadius: "50%",
        background: s.dot,
        display: "inline-block",
        flex: "0 0 auto",
      }}
    />
  );
}

export function StatusChip({ status }: { status: Status }) {
  const s = STATUS[status];
  return (
    <span
      className="chip"
      style={{ color: "var(--ink-2)", background: "var(--bg-chip)" }}
    >
      <StatusDot status={status} />
      {s.label}
    </span>
  );
}

export function RoleChip({ role }: { role: RaciRole }) {
  const r = ROLE[role];
  return (
    <span className="chip" style={{ color: r.color, background: r.bg }}>
      {r.label}
    </span>
  );
}
